export default {"src":"/_next/static/media/chevronRightDark.7cd5a7f6.svg","height":13,"width":8,"blurWidth":0,"blurHeight":0};